<template>
  <div class="dashboard-device-locked">
    {{$lang.messages.kids_mode}}
    <button class="dashboard-device-switch"
            :class="{active: deviceItem ? deviceItem.locked : true}"
            :disabled="switchModeDisabled"
            @click.prevent="toggleKidsMode(deviceID)">
      <span class="dashboard-device-switch-label">{{$lang.messages.dashboard.device.off}}</span>
      <span class="dashboard-device-switch-label">{{$lang.messages.dashboard.device.on}}</span>
    </button>
  </div>
</template>

<script>

import {reportEvent} from "@/helpers/utils";

export default {
  name: 'LockDeviceSwitcher',
  props: ['deviceItem', 'deviceID'],
  data: function() {
    return {
      switchModeDisabled: false
    }
  },
  methods: {
    toggleKidsMode (deviceID) {
      const newKidsModeValue = !this.$store.state.accountData.devices[this.deviceID].locked;
      const newSetting = {
        locked: newKidsModeValue
      }
      if (newKidsModeValue) {
        reportEvent('enterKidsMode')
      } else {
        newSetting.currentProfileID = null
      }
      this.$emit('togglekidsmode', deviceID, newSetting)
      this.switchModeDisabled = true
      setTimeout(() =>  this.switchModeDisabled = false, 1000 )
    },
  }
}

</script>